<template>
    <div class="table offer-info">
        <el-row>
            <el-col span="3">
                <el-button type="primary" @click="copyToNewRound()" v-if="showCopyToNewRound">{{$t("ssrManage.copyToNewRound")}}</el-button>
            </el-col>
<!--            <el-col span="4" offset="17">-->
<!--                <span >{{$t('ssrManage.submitDate')+":"}}{{round.ssrRoundSuppliers[0].submitDate|dateFormatFilter("YYYY-MM-DD")}}</span>-->
<!--            </el-col>-->
        </el-row>
        <div v-if="showPqcp">PQCP
            <!--新增-->
            <el-button type="primary" v-if="canEdit" @click="addPqcp">New</el-button>
            <el-button type="primary" v-if="canEdit" @click="delPqcp">Delete</el-button>
            <pqcp-table :can-edit="canEdit" :data.sync="formData.ssrRoundSupplierPqcps" ref="pqcpList"></pqcp-table>
        </div>
        <div v-if="showPcn">PQCP
            <!--新增-->
            <el-button type="primary" v-if="canEdit" @click="addPcn">New</el-button>
            <el-button type="primary" v-if="canEdit" @click="delPcn">Delete</el-button>
            <pcn-table :can-edit="canEdit" :data.sync="formData.ssrRoundSupplierPcns" ref="pcnList"></pcn-table>
        </div>
        <div style="padding-top: 15px;" v-if="showCostBreakdown">Cost Breakdown
            <!--新增-->
            <el-button type="primary" v-if="canEdit" @click="addCostBreakdown">New</el-button>
            <el-button type="primary" v-if="canEdit" @click="delCostBreakdown">Delete</el-button>
            <capacity-table :roundId="round.ttSsrRoundId" :suppliers="round.ssrRoundSuppliers" :files="round.ssrRoundSuppliers[0].costBreakdownFiles" type="costBreakdown" ref="ssrRoundSupplierCosts" :template="formData.costBreakdownTemplate" :can-edit="canEdit" :data="formData.ssrRoundSupplierCosts"></capacity-table>
        </div>
        <div style="padding-top: 15px;" v-if="showCapacityAnalysis">Capacity Analysis
            <!--新增-->
            <el-button type="primary" v-if="canEdit" @click="addCapacityData">New</el-button>
            <el-button type="primary" v-if="canEdit" @click="delCapacityData">Delete</el-button>
            <capacity-table :roundId="round.ttSsrRoundId" :suppliers="round.ssrRoundSuppliers" :files="round.ssrRoundSuppliers[0].capacityFiles" type="capacityAnalysis" :my-plants="myPlants" ref="ssrRoundSupplierCapacities" :template="formData.capacityTemplate" :can-edit="canEdit" :data="formData.ssrRoundSupplierCapacities"></capacity-table>
            <!--复制产能信息 <production-info-pane/>的table，再稍微改改-->
        </div>
        <div style="padding-top: 15px;" v-if="showLogisticCapacity">Logistics Capacity
            <!--新增-->
            <el-button type="primary" v-if="canEdit" @click="addLogisticCapacity">New</el-button>
            <el-button type="primary" v-if="canEdit" @click="delLogisticCapacity">Delete</el-button>
            <logistic-info-table ref="ssrRoundSupplierLogistics" :data.sync="formData.ssrRoundSupplierLogistics" :can-edit="canEdit"></logistic-info-table>
            <!--复制物流能力<logistics-pane/>的table，再稍微改改-->
        </div>
        <div style="padding-top: 15px;">
            <div>
              <el-card header="SSR Proposal">
                <el-upload v-if="canEdit" ref="proposalDocUpload" :headers="uploadHeader" :show-file-list="false" :action="fileUploadUrl" :on-success="proposalDocUploadSuccess" multiple>
                  <el-button type="primary">Upload</el-button>
                </el-upload>
                <div v-for="(file,index) in formData.ssrRoundSuppliers[0].proposalDocs" :key="index" style="line-height: 40px;">
                  <el-link @click="downloadFile(file)">{{file.documentName}}</el-link>
                  <el-button v-if="canEdit" @click="delProposalDocs(file,index)" type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 20px;"></el-button>
                </div>
              </el-card>
            </div>
            <!--新增-->
            <!--复制供应商Proposal<supplier-pane/>的table，再稍微改改-->
<!--            <el-table :data="[formData.ssrRoundSuppliers[0]]">-->
<!--                <el-table-column prop="supplierCode" :label="$t('ssrManage.invitationCode')"></el-table-column>-->
<!--                <el-table-column prop="supplierName" :label="$t('ssrManage.supplierName')"></el-table-column>-->
<!--                <el-table-column :label="$t('ssrManage.proposalDoc')">-->
<!--                    <template>-->
<!--                        <el-upload v-if="canEdit" ref="proposalDocUpload" :headers="uploadHeader" :show-file-list="false" :action="fileUploadUrl" :on-success="proposalDocUploadSuccess" multiple>-->
<!--                            <el-button type="primary">Upload</el-button>-->
<!--                        </el-upload>-->
<!--                        <div v-for="(file,index) in formData.ssrRoundSuppliers[0].proposalDocs" :key="index" style="line-height: 40px;">-->
<!--                            <el-link @click="downloadFile(file)">{{file.documentName}}</el-link>-->
<!--                            <el-button v-if="canEdit" @click="delProposalDocs(file,index)" type="danger" size="mini" icon="el-icon-delete" circle style="margin-left: 20px;"></el-button>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--&lt;!&ndash;                <el-table-column prop="submitDate" :label="$t('ssrManage.submitDate')">&ndash;&gt;-->
<!--&lt;!&ndash;                    <template slot-scope="scope">&ndash;&gt;-->
<!--&lt;!&ndash;                        {{scope.row.submitDate|dateFormatFilter("YYYY-MM-DD")}}&ndash;&gt;-->
<!--&lt;!&ndash;                    </template>&ndash;&gt;-->
<!--&lt;!&ndash;                </el-table-column>&ndash;&gt;-->
<!--                <el-table-column :label="$t('ssrManage.summarize')">-->
<!--                    <template>-->
<!--                        <el-input :disabled="!canEdit" v-model="formData.ssrRoundSuppliers[0].proposalRemark"></el-input>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--            </el-table>-->
        </div>
        <file-upload :disabled="!canEdit" v-if="showOtherFormat"
                     title="Other  Format" :show-file-list="false" v-model="formData.ssrRoundSuppliers[0].otherFormat" multiple
                     :biz-id="formData.ssrRoundSuppliers[0].ttSsrRoundSupplierId" rec-type="SSR" seq="OTHER_FORMAT">
            <template v-slot:header>
                <el-button type="primary" @click="downloadSsrOtherFormat">Download</el-button>
            </template>
        </file-upload>
        <!--底部操作按钮-->
        <el-row type="flex" justify="center" style="padding-top: 15px;">
            <el-button v-if="canEdit" type="primary" @click="save('SUBMIT')">Submit</el-button>
            <el-button v-if="canEdit" type="primary" @click="save('DRAFT')">Save As Draft</el-button>
        </el-row>
    </div>
</template>
<script>
    import router from '../../../router';
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import commonFun from "@/utils/commonFun";
    import commonConstatns from "@/constants/commonConstants";
    import {fileService} from "@/api/common/file-utils";
    import FileUpload from "@/components/common/fileUpload";
    import CapacityTable from "@/components/page/ssr-manage/capacity-table";
    import LogisticInfoTable from "@/components/page/ssr-manage/logistic-info-table";
    import PqcpTable from "@/components/page/ssr-manage/pqcp-table";
    import PcnTable from "@/components/page/ssr-manage/pcn-table";
    import supplier from "@/api/supplier/supplier";

    export default {
        name: 'proposal-pane',
        extends: commonMethods,
        components: {PqcpTable,PcnTable, LogisticInfoTable, CapacityTable, FileUpload},
        props: {
            showCopyToNewRound:Boolean,
            round: Object,
            ssr: Object,
        },
        computed: {
            uploadHeader() {
                return {'x-access-token': localStorage.getItem('token')};
            },
            fileUploadUrl() {
                return `${commonConstatns.fileUploadUrl}/SSR/PROPOSAL/${this.formData.ssrRoundSuppliers[0].ttSsrRoundSupplierId}`
            },
            showPqcp() {
                if (this.formData.status == 'ISSUED' || commonFun.isEmpty(this.formData.status)) {
                    return this.ssr.needPqcp == 'Y';
                } else {
                    return commonFun.isNotEmpty(this.formData.ssrRoundSupplierPqcps);
                }
            },
            showPcn() {
                if (this.formData.status == 'ISSUED' || commonFun.isEmpty(this.formData.status)) {
                    return this.ssr.needPcn == 'Y';
                } else {
                    return commonFun.isNotEmpty(this.formData.ssrRoundSupplierPcns);
                }
            },
            showCostBreakdown() {
                if (this.formData.status == 'ISSUED' || commonFun.isEmpty(this.formData.status)) {
                    return this.ssr.needCostBreakdown == 'Y';
                } else {
                    return commonFun.isNotEmpty(this.formData.ssrRoundSupplierCosts) || commonFun.isNotEmpty(this.round.costBreakdownFiles);
                }
            },
            showLogisticCapacity() {
                if (this.formData.status == 'ISSUED' || commonFun.isEmpty(this.formData.status)) {
                    return this.ssr.needLogisticCapacity == 'Y';
                } else {
                    return commonFun.isNotEmpty(this.formData.ssrRoundSupplierLogistics) ;
                }
            },
            showCapacityAnalysis() {
                if (this.formData.status == 'ISSUED' || commonFun.isEmpty(this.formData.status)) {
                    return this.ssr.needCapacityAnalysis == 'Y';
                } else {
                    return commonFun.isNotEmpty(this.formData.ssrRoundSupplierCapacities)|| commonFun.isNotEmpty(this.round.supplierCapacityFiles);
                }
            },
            showOtherFormat() {
                if (this.formData.status == 'ISSUED' || commonFun.isEmpty(this.formData.status)) {
                    return this.ssr.needOtherFormat == 'Y';
                } else {
                    return commonFun.isNotEmpty(this.formData.ssrRoundSuppliers[0].otherFormat);
                }
            },
            canEdit() {
                return commonFun.isSupplier() && this.formData.status == "ISSUED" && ["NEW","REFUSE"].indexOf(this.formData.ssrRoundSuppliers[0].status) <0;
            }
        },
        data() {
            return {
                formData: {
                    costBreakdownTemplate: {},
                    ssrRoundSupplierCapacities: [],
                    ssrRoundSupplierCosts: [],
                    ssrRoundSupplierLogistics: [],
                    ssrRoundSupplierPqcps: [],
                    ssrRoundSupplierPcns: [],
                    supplierCode: '',
                    supplierName: '',
                    address: '',
                },
                myPlants: [],
                radio: '1',
                labelPosition: 'right',
                pqcpList: [{ssrNo: 'aaa', radio: 1}],
                facilityOption: [],
                currencyOption: [],
            }
        },
        created() {
            this.formData = this.round;
            let that = this;
            supplier.getMyPlantList().then(res=>{
                that.myPlants = res.data;
            })
        },
        methods: {
            downloadSsrOtherFormat() {
                fileService.downLoadZip({
                    recIds: [this.ssr.ttSsrId],
                    tsReckindId: "SSR",
                    seq: "SSR_OTHER_FORMAT",
                    names:[this.ssr.name]
                }).then(resp => {
                    fileService.respToFile(resp);
                });
            },
            copyToNewRound() {
                this.$emit("copyToNewRound",this.round);
            },
            save(status) {
                let that = this;

                let data = {
                    ttSsrRoundId: this.formData.ttSsrRoundId,
                    costBreakdownList: this.formData.ssrRoundSupplierCosts.map(value => value.data),
                    capacityList: this.formData.ssrRoundSupplierCapacities.map(value => value.data),
                    logisticList: this.formData.ssrRoundSupplierLogistics,
                    proposal: this.formData.ssrRoundSuppliers[0].proposalRemark,
                    otherFormat: this.formData.ssrRoundSuppliers[0].otherFormat,
                    proposalDocs: this.formData.ssrRoundSuppliers[0].proposalDocs,
                    costBreakdownFiles: this.formData.ssrRoundSuppliers[0].costBreakdownFiles,
                    supplierCapacityFiles: this.formData.ssrRoundSuppliers[0].supplierCapacityFiles,
                    status: status,
                }
                data.pqcpList = JSON.parse(JSON.stringify(this.formData.ssrRoundSupplierPqcps)).map(pqcp=>{
                    pqcp.supplierDc = JSON.stringify(pqcp.supplierDc);
                    return pqcp;
                });
                data.pcnList = JSON.parse(JSON.stringify(this.formData.ssrRoundSupplierPcns)).map(pcn=>{
                    pcn.supplierDc = JSON.stringify(pcn.supplierDc);
                    return pcn;
                });

                var valid = new Promise(resolve => resolve());
                if (status == "SUBMIT") {

                    if (this.ssr.needPqcp == "Y" && commonFun.isEmpty(this.formData.ssrRoundSupplierPqcps)) {
                        Message.warning(this.$t("ssrManage.needPqcp"));
                        return;
                    }if (this.ssr.needPcn == "Y" && commonFun.isEmpty(this.formData.ssrRoundSupplierPcns)) {
                        Message.warning(this.$t("ssrManage.needPqcp"));
                        return;
                    }if (this.ssr.needLogisticCapacity == "Y" && commonFun.isEmpty(this.formData.ssrRoundSupplierLogistics)) {
                        Message.warning(this.$t("ssrManage.needLogisticCapacity"));
                        return;
                    }if (this.ssr.needOtherFormat == "Y" && commonFun.isEmpty(this.formData.ssrRoundSuppliers[0].otherFormat)) {
                        Message.warning(this.$t("ssrManage.needOtherFormat"));
                        return;
                    }
                    let validArr = [];
                    if (this.showPqcp) {
                        validArr.push(this.$refs.pqcpList.$refs.form.validate());
                    }
                    if (this.showPcn) {
                        validArr.push(this.$refs.pcnList.$refs.form.validate());
                    }

                    if (this.showCostBreakdown) {
                      validArr.push(apiService.countRoundSupplierCostBreakdownFiles(that.formData.ttSsrRoundId).then(res=>{
                            if (res.code == '200') {
                              if (res.data <= 0) {
                                if (commonFun.isEmpty(this.formData.ssrRoundSupplierCosts)) {
                                  Message.warning(this.$t("ssrManage.needCostBreakdown"));
                                  return new Promise((resolve, reject) => reject(new Error(this.$t("ssrManage.needCostBreakdown"))));
                                } else {
                                  return this.$refs.ssrRoundSupplierCosts.$refs.form.validate();
                                }
                              } else {
                                return new Promise(resolve => resolve(true));
                              }
                            }
                          })
                      )
                    }
                    if (this.showCapacityAnalysis) {
                        validArr.push(fileService.countFile({
                            tsRecId:that.round.ssrRoundSuppliers[0].ttSsrRoundSupplierId,
                            tsReckindId:'SSR',
                            seq:'SUPPLIER_CAPACITY',
                            }).then(res=>{
                                if (res.code == '200') {
                                    if (res.data <= 0) {
                                        if (commonFun.isEmpty(this.formData.ssrRoundSupplierCapacities)) {
                                            Message.warning(this.$t("ssrManage.needCapacityAnalysis"));
                                            return new Promise((resolve, reject) => reject(new Error(this.$t("ssrManage.needCapacityAnalysis"))));
                                        } else {
                                            return this.$refs.ssrRoundSupplierCapacities.$refs.form.validate();
                                        }
                                    } else {
                                        return new Promise(resolve => resolve(true));
                                    }
                                }
                            })
                        )
                    }
                    if (this.showLogisticCapacity) {
                        validArr.push(this.$refs.ssrRoundSupplierLogistics.$refs.form.validate());
                    }
                    valid = Promise.all(validArr);
                }
                valid.then((flag) => {
                    apiService.quote(data).then(res => {
                        if (res.code == 200) {
                            that.formData.status = status;
                            if (status == 'SAVE') {
                                Message.success('Save Success');
                            }else if (status == "SUBMIT") {
                                Message.success('Submit Success');
                            }
                            that.$store.dispatch("reload");
                        }
                    })
                }).catch(res=>{
                    if (!res) {
                        Message.error(that.$t('ssrManage.proposeRequire'));
                    }
                })
            },
            downloadFile(file) {
                fileService.downloadFile(file);
            },
            delProposalDocs(file, index) {
                let that = this;
                let delIndex = null;
                fileService.deleteFile(file.tmDocumentId).then(res => {
                    if (res.code == '200') {
                        that.formData.ssrRoundSuppliers[0].proposalDocs.splice(index, 1);
                    }
                });
            },
            addPqcp() {
                this.formData.ssrRoundSupplierPqcps.push({isNew: 'N', currency: "RMB",localItem:""});
            },
            delPqcp() {
                this.$refs.pqcpList.delSelect()
            },
            addPcn() {
                let maxGroupId = 0;
                this.formData.ssrRoundSupplierPcns.forEach(pcn=>{
                    maxGroupId = pcn.groupId > maxGroupId ? pcn.groupId : maxGroupId;
                })
                this.formData.ssrRoundSupplierPcns.push(...[
                    {groupId:maxGroupId+1,productDescription:'Transportation'},
                    {groupId:maxGroupId+1,productDescription:'Warehouse'},
                ]);
            },
            delPcn() {
                this.$refs.pcnList.delSelect()
            },
            delCostBreakdown() {
                this.$refs.ssrRoundSupplierCosts.delSelect()
            },
            delCapacityData() {
                this.$refs.ssrRoundSupplierCapacities.delSelect()
            },
            delLogisticCapacity() {
                this.$refs.ssrRoundSupplierLogistics.delSelect()
            },
            addCostBreakdown() {
                let emptyData = this.formData.costBreakdownTemplate.columns.map(column => "");
                this.formData.ssrRoundSupplierCosts.push({data: {columns: emptyData}});
            },
            addCapacityData() {
                let emptyData = this.formData.capacityTemplate.columns.map(column => "");
                emptyData[0] = JSON.parse(localStorage.getItem("supplierObj")).supplierName;
                this.formData.ssrRoundSupplierCapacities.push({data: {columns: emptyData,capacityFiles:[]}});
            },
            addLogisticCapacity() {
                let supplierCode = this.round.ssrRoundSuppliers[0].supplierCode;
                let supplierNameShort = this.round.ssrRoundSuppliers[0].supplierNameShort;
                this.formData.ssrRoundSupplierLogistics.push({supplierCode:supplierCode,supplierNameShort:supplierNameShort});
            },
            proposalDocUploadSuccess(response, file, fileList) {
                if (null == this.formData.ssrRoundSuppliers[0].proposalDocs) {
                    this.formData.ssrRoundSuppliers[0].proposalDocs = [];
                }
                this.formData.ssrRoundSuppliers[0].proposalDocs.push(...(commonFun.convertToArray(response.data)));
            },
        },
        watch: {
            round(val) {
                this.formData = val;
            },
            formData(val) {
                this.$emit("update:round", this.formData);
            }
        }
    }
</script>
<style>
    .offer-info .el-table__body .el-radio .el-radio__label {
        display: inline-block !important;
    }
</style>
